import { format, parseISO, differenceInCalendarDays } from 'date-fns';

export function formatDate(iso: string): string {
  return format(parseISO(iso), 'd MMM yyyy');
}

export function postedLabel(iso: string, today = new Date('2026-10-22')): string {
  const days = differenceInCalendarDays(today, parseISO(iso));
  if (days <= 0) return 'Posted today';
  if (days === 1) return 'Posted yesterday';
  if (days < 14) return `Posted ${days} days ago`;
  return `Posted ${formatDate(iso)}`;
}
